export default __webpack_public_path__ + "static/media/Group96.547c06f0.png";